<script>
import { CLASS_NAME_COMPONENT } from "./common";

export default {
  name: "TgSavedToast",
  props: {
    text: {
      type: String,
      default: "Gemt"
    },
    tag: {
      type: String,
      default: "output"
    },
    transitionName: {
      type: String,
      default: "fade"
    },
    transitionDuration: {
      type: [Number, Object],
      default: 200
    },
    show: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 2500
    },
    absolute: {
      type: Boolean,
      default: false
    },
    top: {
      type: [Number, String],
      default: undefined
    },
    bottom: {
      type: [Number, String],
      default: undefined
    },
    left: {
      type: [Number, String],
      default: undefined
    },
    right: {
      type: [Number, String],
      default: undefined
    }
  },
  emits: ["update:show"],
  data() {
    return {
      timer: null,
      showFromTimer: false
    };
  },
  computed: {
    baseClass() {
      return CLASS_NAME_COMPONENT;
    },

    showToast() {
      return this.showFromTimer;
    },

    styles() {
      const styles = {};

      if (this.absolute) {
        styles.position = "absolute";
      }

      if (this.top !== undefined) {
        styles.top = this.parseStyleValue(this.top);
      }

      if (this.bottom !== undefined) {
        styles.bottom = this.parseStyleValue(this.bottom);
      }

      if (this.left !== undefined) {
        styles.left = this.parseStyleValue(this.left);
      }

      if (this.right !== undefined) {
        styles.right = this.parseStyleValue(this.right);
      }

      return styles;
    }
  },
  watch: {
    show(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      clearTimeout(this.timer);

      if (newValue === true) {
        this.showFromTimer = true;

        this.timer = setTimeout(() => {
          this.showFromTimer = false;
          this.$emit("update:show", false);
        }, this.timeout);
      }

      if (newValue === false) {
        this.showFromTimer = false;
      }
    }
  },
  methods: {
    parseStyleValue(value) {
      if (typeof value === "number") {
        return `${value}px`;
      }

      return value;
    }
  }
};
</script>

<template>
  <Transition :name="transitionName" :duration="transitionDuration">
    <Component
      :is="tag"
      v-if="showToast"
      :class="baseClass"
      :style="styles"
      role="status"
      aria-live="polite"
    >
      <svg
        :class="`${baseClass}__icon`"
        role="presentation"
        width="19"
        height="13"
        viewBox="0 0 19 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.9505 0.412036C16.4409 -0.112347 17.2636 -0.139887 17.788 0.350525C18.2796 0.810286 18.3345 1.56206 17.9354 2.08631L17.8495 2.18797L8.12323 12.588C7.63967 13.105 6.83933 13.1354 6.3185 12.6792L6.22427 12.588L0.350525 6.30735C-0.139887 5.78297 -0.112347 4.96031 0.412036 4.4699C0.903645 4.01014 1.65741 4.00561 2.15379 4.43892L2.24948 4.53141L7.1734 9.7968L15.9505 0.412036Z"
          fill="currentColor"
        />
      </svg>

      <span v-text="text" />
    </Component>
  </Transition>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";
@import "@/abc-dsk/styles/transitions.less";

@primary-color: rgb(@theme-colors[@primary][base]);

.tg-saved-toast {
  display: flex;
  align-items: center;
  color: @primary-color;

  &__icon {
    margin-right: 8px;
  }
}
</style>
